import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hover:border hover:border-gray-300 hover:shadow-lg rounded-md px-2 py-3 cursor-pointer" }
const _hoisted_2 = { class: "font-medium text-gray-900 border-tea" }
const _hoisted_3 = { class: "font-normal text-gray-400" }

interface Props {
    color: string
    title: string
    description: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionItem',
  props: {
    color: {},
    title: {},
    description: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`pl-2 flex flex-col gap-y-1 text-sm leading-5 border-l-2 border-l-${_ctx.color}`)
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.description), 1)
    ], 2)
  ]))
}
}

})